/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The ChecklistStateDTO model module.
 * @module model/ChecklistStateDTO
 * @version v0
 */
export class ChecklistStateDTO {
  /**
   * Constructs a new <code>ChecklistStateDTO</code>.
   * @alias module:model/ChecklistStateDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistStateDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistStateDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistStateDTO} The populated <code>ChecklistStateDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistStateDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ChecklistStateDTO.prototype.id = undefined;

/**
 * @member {String} name
 */
ChecklistStateDTO.prototype.name = undefined;

